export const REQUEST_TOKEN = 'REQUEST_TOKEN';
export const CREATE_USER = 'CREATE_USER';
export const AUTH_PROCESSING = 'AUTH_PROCESSING';
